class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/events`;
    }
    /**
     * Returns a list of calendar events available for the current user within the specified group. Users can only see their personal tasks and public tasks.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/groups/{groupId}/events
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new calendar event within the specified group.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/groups/{groupId}/events
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async post(tMCreateEventRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), tMCreateEventRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
